// Firebase Configuration
// Values from firebase_app.json; env vars override if present
export const firebaseConfig = {
  apiKey:            import.meta.env.VITE_FIREBASE_API_KEY            || 'AIzaSyB1U3tLP_VDgLvRHjKU5z0S-Wb9JtuUnjc',
  authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN        || 'datalogichub.firebaseapp.com',
  projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID         || 'datalogichub',
  storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET     || 'datalogichub.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '915865568351',
  appId:             import.meta.env.VITE_FIREBASE_APP_ID             || '1:915865568351:web:61e12db801b16f095c47ea',
  // Required for Firebase Analytics — set VITE_GA_MEASUREMENT_ID in your .env files
  measurementId:     import.meta.env.VITE_GA_MEASUREMENT_ID,
};

// API Configuration
export const apiConfig = {
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
};

// App Configuration
export const appConfig = {
  name: import.meta.env.VITE_APP_NAME || 'Byamba Enkhbat',
  version: import.meta.env.VITE_APP_VERSION || '1.0.0',
  environment: import.meta.env.VITE_ENVIRONMENT || 'development',
};

// Google Analytics
export const analyticsConfig = {
  measurementId: import.meta.env.VITE_GA_MEASUREMENT_ID,
};

// Firebase App Check — reCAPTCHA v3
// Set VITE_RECAPTCHA_SITE_KEY in your .env file (never commit the raw key)
export const appCheckConfig = {
  recaptchaSiteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY || '',
};

// Content Loop review Cloud Functions (tick 3.1, ARCHITECTURE.md §2). Each is
// a Firebase Gen2 function with its own Cloud Run URL. The default below
// follows the same project hash suffix as the other deployed gen2 functions
// (social.js/mongol.js/coderjs_x.js/likeByKeyword.js/etc.) but hasn't been
// verified against a live deploy from this environment (no gcloud/Firebase
// auth here — see MEMORY.json) — override via env if the real deployed URL
// differs once the owner deploys these functions.
export const contentLoopApiConfig = {
  listReviewItemsUrl:
    import.meta.env.VITE_CONTENT_LOOP_LIST_URL || 'https://contentlooplistreviewitems-kqkx75ya2a-uc.a.run.app',
  reviewItemUrl:
    import.meta.env.VITE_CONTENT_LOOP_REVIEW_URL || 'https://contentloopreviewitem-kqkx75ya2a-uc.a.run.app',
};

// Admin analytics Cloud Functions (functions/lib/analytics/ga4.js). Same gen2
// URL convention as the content-loop endpoints above — override via env if
// the deployed URLs differ.
export const analyticsApiConfig = {
  reportUrl:
    import.meta.env.VITE_ANALYTICS_REPORT_URL || 'https://analyticsga4report-kqkx75ya2a-uc.a.run.app',
  assistantUrl:
    import.meta.env.VITE_ANALYTICS_ASSISTANT_URL || 'https://analyticsassistant-kqkx75ya2a-uc.a.run.app',
};

// Follower-growth admin chart (functions/lib/content_loop/accountGrowthReport.js).
// Same gen2 URL convention as the endpoints above — override via env if the
// deployed URL differs once the owner deploys the function.
export const accountGrowthApiConfig = {
  reportUrl:
    import.meta.env.VITE_ACCOUNT_GROWTH_URL ||
    // Stable cloudfunctions.net alias printed by `firebase deploy` — verified
    // live 2026-07-23. (gen2 functions also expose a *.run.app URL, but this
    // alias is deterministic and doesn't depend on the project hash.)
    'https://us-central1-datalogichub.cloudfunctions.net/contentLoopAccountGrowth',
};
